module.exports = __webpack_public_path__ + "img/cuba-libre.c22fe26c.jpg";